// The app's only stylesheet import.
import './styles.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider, CssBaseline, GlobalStyles, StyledEngineProvider } from '@mui/material';
import { RouterProvider } from 'react-router-dom';

import { AuthProvider } from '../shared/components/AuthProvider';
import { ConfirmProvider } from '../shared/components/ConfirmProvider';
import { store } from '../store';
import theme from '../shared/theme/new-theme-modern';

import { router } from './routes';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    {/* MUI's documented Tailwind v4 setup for Vite. Two halves, both required.
        See https://mui.com/material-ui/integrations/tailwindcss/tailwindcss-v4/

        `enableCssLayer` wraps everything Emotion emits in `@layer mui`. Without it,
        MUI's styles stay unlayered — and unlayered author CSS outranks every layer,
        so no Tailwind utility could override an `sx` prop.

        `GlobalStyles` declares the layer order, and **must stay the first child of
        StyledEngineProvider, above CssBaseline**. Cascade-layer order is fixed by
        first appearance, and MUI hoists its global styles to the very top of <head>
        (styled-engine prepends an `emotion-insertion-point` meta and inserts globals
        before it). So whichever global renders first wins. If CssBaseline got there
        first, `mui` would register as the lowest layer and Tailwind Preflight's
        `* { margin: 0; padding: 0 }` would beat every MUI style in the application.

        The bare statement survives the `enableCssLayer` wrapper because the
        interceptor deliberately exempts `@layer a, b, c;` from being nested.

        Order is asserted at runtime in css-layers.test.tsx, and structurally in
        tools/check-css-layer-order.mjs. */}
    <StyledEngineProvider enableCssLayer>
      <GlobalStyles styles="@layer theme, base, mui, components, utilities;" />
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <ConfirmProvider>
            <AuthProvider>
              <RouterProvider router={router} />
            </AuthProvider>
          </ConfirmProvider>
        </ThemeProvider>
      </Provider>
    </StyledEngineProvider>
  </React.StrictMode>
);
